<template>
  <div>
    <div class="row">
      <div class="small-12 columns">
        <h1 style="text-align:center">External Referrals</h1>
        <div class="referral-container">
          <div class="row">
            <div class="small-12 columns">
              <div class="small-4 columns">
                <input
                  v-model="referralName"
                  class="form-input"
                  type="text"
                  name="name"
                  placeholder="Name of the referral"
                />
              </div>
              <div class="small-4 columns">
                <input
                  v-model="referralCode"
                  class="form-input"
                  type="text"
                  name="code"
                  placeholder="Referral Code"
                />
              </div>
              <div class="small-4 columns">
                <button class="button-green add-button" @click="addReferral()">
                  Add Referral
                </button>
              </div>
              <div v-if="errorMessage" class="small-12 columns">
                <p style="color:red;text-align:center;">{{ errorMessage }}</p>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="small-12 columns">
        <div class="row">
          <div class="small-12 columns">
            <table>
              <thead>
                <th>Name</th>
                <th>Code</th>
                <th colspan="2">Options</th>
              </thead>
              <tbody>
                <tr v-for="referral in referralList" :key="referral.id">
                  <td>{{ referral.name }}</td>
                  <td>{{ referral.referral_code }}</td>
                  <td>
                    <span
                      class="options-edit link"
                      @click="openEditForm(referral)"
                      >Edit</span
                    >
                  </td>
                  <td>
                    <span
                      class="options-archive link"
                      @click="archiveReferral(referral)"
                      >Archive</span
                    >
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
    <div
      class="referral-edit-container"
      :class="{ 'show-edit-form': showEditForm }"
    >
      <div class="small-12 columns">
        <div class="small-12 columns">
          <input
            v-model="activeRefferalItem.name"
            class="form-input"
            type="text"
            name="name"
            placeholder="Name of the referral"
          />
        </div>
        <div class="small-12 columns">
          <input
            v-model="activeRefferalItem.referral_code"
            class="form-input"
            type="text"
            name="code"
            placeholder="Referral Code"
          />
        </div>
        <div class="small-12 columns">
          <button class="button-green edit-button" @click="editReferral()">
            Update
          </button>
        </div>
      </div>
      <div class="close-button" @click="closeEditForm"><span>X</span></div>
    </div>
  </div>
</template>

<script>
import siteConfig from "@/utils/siteConfig"

export default {
  data() {
    return {
      referralList: [],
      referralName: undefined,
      referralCode: undefined,
      showEditForm: false,
      errorMessage: undefined,
      activeRefferalItem: {
        id: undefined,
        name: undefined,
        referral_code: undefined,
      },
    }
  },
  mounted() {
    this.listReferrals()
  },
  methods: {
    listReferrals() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/referrals?skip=0&limit=100`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.referralList = [...res.data.items]
      })
    },
    addReferral() {
      this.axios({
        method: "post",
        url: `${siteConfig.siteURL}admin/referrals`,
        data: { name: this.referralName, referral_code: this.referralCode },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      })
        .then(() => {
          this.referralName = undefined
          this.referralCode = undefined
          this.errorMessage = undefined
          this.listReferrals()
        })
        .catch(() => {
          this.errorMessage =
            "Error creating referral. Please check you enter valid input."
        })
    },
    openEditForm(referral) {
      this.showEditForm = true
      this.activeRefferalItem = { ...referral }
    },
    closeEditForm() {
      this.showEditForm = false
    },
    editReferral() {
      this.axios({
        method: "put",
        url: `${siteConfig.siteURL}admin/referrals/${this.activeRefferalItem.id}`,
        data: { name: this.activeRefferalItem.name },
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.closeEditForm()
        this.referralName = undefined
        this.referralCode = undefined
        const cleanedObj = {
          id: undefined,
          name: undefined,
          referral_code: undefined,
        }
        this.activeRefferalItem = { ...cleanedObj }
        this.listReferrals()
      })
    },
    archiveReferral(referral) {
      this.axios({
        method: "delete",
        url: `${siteConfig.siteURL}admin/referrals/${referral.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(() => {
        this.listReferrals()
      })
    },
  },
}
</script>

<style scoped>
.form-input {
  padding-left: 15px;
  border-radius: 15px;
  outline: 0;
}
.add-button {
  height: 30px;
  padding: 6px 46px;
}
.edit-button {
  width: 90%;
  height: 30px;
  padding: 6px 46px;
  color: #ffffff;
}
.close-button {
  position: absolute;
  top: 10px;
  right: 10px;
  padding: 7px;
  border: 1px solid red;
  border-radius: 50%;
  color: red;
  cursor: pointer;
}
.close-button:hover {
  color: #ffffff;
  background-color: red;
}

.referral-container {
  width: 90%;
  margin-bottom: 30px;
  padding: 20px;
  background-color: #ffffff;
  box-shadow: 1px 1px 10px rgba(0, 0, 0, 0.3);
}
.referral-edit-container {
  display: none;
  position: absolute;
  z-index: 9999999;
  top: 40%;
  left: 20%;
  width: 50%;
  padding: 30px;
  background-color: #ffffff;
  box-shadow: 1px 15px 10px rgba(0, 0, 0, 0.3);
  text-align: center;
  transition: all 0.35s ease-in-out;
}
.show-edit-form {
  display: block;
}
.options-edit {
  color: blue;
}
.options-archive {
  color: red;
}
table {
  width: 90%;
}
th,
td {
  text-align: center;
}
</style>
